export default __webpack_public_path__ + "static/media/white_check.1932ba6a.svg";